import axiosIns from 'utils/axios'
let epmcore = 'EPM-CORE-SERVICE'


// 获取项目干系人
export function getProjectContactPerson (id) {
  return axiosIns({
    url: `/api/pc/projectContactPerson/get/${id}`,
    owner: epmcore,
    method: 'get'
  })
}


// 更新项目干系人
export function updateProjectContactPerson (data) {
  return axiosIns({
    url: `/api/pc/projectContactPerson/update`,
    owner: epmcore,
    method: 'put',
    data: data
  })
}
// 新增项目干系人
export function addProjectContactPerson (data) {
  return axiosIns({
    url: `/api/pc/projectContactPerson/add`,
    owner: epmcore,
    method: 'post',
    data: data
  })
}
// 删除项目干系人
export function removeProjectContactPersonById (id) {
  return axiosIns({
    url: `/api/pc/projectContactPerson/delete/${id}`,
    owner: epmcore,
    method: 'delete'
  })
}


// WEBPACK FOOTER //
// ./src/views/project-manage/contactAPI.js